"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.knowledge.title': 'Otwórz Wybór Wiedzy',
    'shortcuts.knowledge.description': 'Otwiera selektor wiedzy do wyszukiwania i wybierania źródeł wiedzy',
};
